<template>
  <div class="login_container">
    <div class="img-form">
      <el-dropdown class="message-wrap" placement="bottom" :show-timeout="0">
        <el-button type="primary" size="mini" plain>{{ $t('_lang') }}</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(val, key) in i18nMessages" :key="key" @click.native="changeLang(key)">{{ val._lang }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="login_box pon">
        <!-- 表单 -->
        <div class="login_box_content">
          <div class="img-container">
            <!--            <img src="../assets/images/login/login_biaoti.png" alt="">-->
            <!-- <img src="../assets/images/login/login_biaoti8.png" alt=""> -->
            <img src="../assets/images/logo7.png" alt="">
          </div>
          <div
            style="text-align: center;font-size: 17px;color: #fff;margin-bottom: 15px;cursor: pointer;"
            @click="handleOpen"
          >
            ホームページに戻る
          </div>
          <el-form ref="LoginFormRef" :model="loginForm" label-width="0" :rules="LoginFormRules" class="login_form">

            <el-form-item prop="loginType">
              <el-radio-group v-model="loginType" size="medium" class="login-type" fill="#3e8ef7">
                <el-radio-button label="0">{{$t('system.noneTitle')}}</el-radio-button>
                <el-radio-button label="1">{{$t('system.haveTitle')}}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item prop="userName">
              <el-input v-model="loginForm.userName" prefix-icon="el-icon-user-solid" :placeholder="$t('login.login1')">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password"
                :placeholder="$t('loginR.login16')" @keyup.enter.native="login"></el-input>
            </el-form-item>
            <span style="float:left;height:22px;line-height:20px">
              <el-link type="primary" :underline="false" @click="logisticsUrl">{{$t('logistics.logistics1')}}</el-link>
            </span>
            <el-link type="info" style="float:right;font-size: 10px;" :underline="false" @click="resetPassword">
              <span style="font-size: 10px;">{{$t('loginR.login1')}}</span>
            </el-link>
            <div class="btn-wrap">
              <el-button class="btns" type="primary" @click="login" size="small"><span>{{$t('login.login2')}}</span></el-button>
            </div>
            <div class="registerText" style="overflow:hidden">
              <span style="float:left;height:22px;line-height:22px;margin-right:5px">{{$t('loginR.login2')}}</span>
              <span style="float:left;height:22px;line-height:20px">
                <el-link type="primary" :underline="false" @click="register">{{$t('loginR.login8')}}</el-link>
              </span>
            </div>
          </el-form>
        </div>
        <!-- <div class="registerText" style="overflow:hidden">
          <span style="float:left;height:22px;line-height:22px;margin-right:5px">{{$t('loginR.login2')}}</span>
          <span style="float:left;height:22px;line-height:20px">
            <el-link type="primary" :underline="false" @click="register">{{$t('loginR.login8')}}</el-link>
          </span>
        </div> -->
        <!-- 物流查询 -->
        <!-- <div class="registerText" style="overflow:hidden">
           <span  style="float:left;height:22px;line-height:20px"><el-link type="primary" :underline="false" @click="logisticsUrl">{{$t('logistics.logistics1')}}</el-link></span>
        </div> -->

        <!-- <div class="filing">
          <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2021007835号-3</a>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { messages, setLang } from '@/i18n'

export default {
  data () {
    return {
      i18nMessages: messages,
      loginType : 1,
      loginForm: {
        userName: '',
        password: ''
      },
      LoginFormRules: {
        userName: [
          { required: true, message: this.$t('login.login3'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('loginR.login16'), trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    handleOpen(){
      window.open('https://aribabadaikou.com/')
    },
    changeLang (key) {
      this.$i18n.locale = key
      setLang(key)
    },
    resetPassword () {
      this.$router.push({
        name: 'resetPassword'
      })
    },
    resetLoginForm () {
      this.$refs.LoginFormRef.resetFields()
    },
    login () {
      this.$refs['LoginFormRef'].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post('admin/login', this.loginForm)
          if (res.code == 200) {
            this.$message({
              message: this.$t('login.login4'),
              type: 'success',
              duration: 500
            })
            window.sessionStorage.setItem('token', res.data.tokenHead + res.data.token);
            window.sessionStorage.setItem('tokenValue', res.data.token);
            //权限数组
            // var authArr = ['add','edit'];
            // window.sessionStorage.setItem('auth',authArr.toString());
            this.$router.push('/');
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        } else {
          return false
        }
      })
    },
    register () {
      window.sessionStorage.clear();
      this.$router.push({ name: 'register' });
    },
    // 跳转到物流查询
    logisticsUrl () {
      this.$router.push({ name: 'logisticsInfo' });
    },
  },
  watch: {
    loginType(val) {
      const isProduction = process.env.NODE_ENV === "production";
      if(isProduction){
        if (val == 0){
          window.location.href  = "https://www.muzaiko-vip.com/muzaiko"
        }
      }else{
        if (val == 0){
          window.location.href  = "http://zhaoke-muzaiko-user-web.pulaien.cn"
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.el-form-item {
  height: 40px !important;
}
.el-input__inner {
  font-size: inherit;
}
.login_container {
  height: 100%;
  width: 100%;
  background: url("../assets/images/login_bg.png") no-repeat;
  background-size: cover;
  background-position: 0 0;
}
//.login_box{
//  position: relative;
//}
.btn-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}
.registerText {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  // position: absolute;
  // bottom: -4%;
  // right: 26%;
}
.login_box_content {
  //padding: 15%;
  //padding-top: 45%;
  .img-container {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    img {
      //width: 188px;
      height: 66px;
      width: 288px;
    }
  }
}

.img-form {
  overflow: hidden;
  height: 100%;
  position: relative;
  .message-wrap {
    position: absolute;
    top: 30px;
    right: 30px;
  }
  .avatar_box {
    position: relative;
    //float: left;
    width: 100%;
    height: 100%;
    display: none;
    img {
      width: 100%;
      height: 100%;
    }
  }
  // .login_box {
  //   //float: left;
  //   position: absolute;
  //   width: 290px;
  //   height: 326px;
  //   left: 208px;
  //   //margin: 0 auto;
  //   top: 50%;
  //   margin-top: -163px;
  //   //background-color: red;
  // }
  .login_box {
    // display: flex;
  }
}
@media screen and (min-width: 1600px) {
  //.avatar_box{
  //  width: 75% !important;
  //}
  //.login_box{
  //  width: 25% !important;
  //}
}

.login_form {
  bottom: 0;
  width: 400px;
  padding: 20px 30px;
  // box-sizing: border-box;
  background-color: #fff;
  border-radius: 15px;
}
.btns {
  margin-top: 20px;
  width: 263px;
  height: 38px;
  background: #3e8ef7;
  border-radius: 20px;
  color: #ffffff;
}
.btns span {
  font-size: 17px !important;
  letter-spacing: 5px;
}

/deep/ .el-input__prefix,
.el-input__suffix {
  color: #3e8ef7 !important;
}

/deep/ .el-input__icon .el-icon-user-solid {
  color: #3e8ef7 !important;
}
.footer-container {
  width: 100%;
  position: absolute;
  bottom: 10%;
  text-align: center;
}
.footer {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  letter-spacing: 4px;
  color: #fefeff;
}

.about {
  font-size: 16px;
  font-family: Source Han Sans CN;
  // font-weight: 400;
  color: #fefeff;
  padding-top: 10px;
}
/deep/ .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #e5e9f8 !important;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.pon {
  // position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: flex-start;
  padding: 50px 20px 150px;
  margin-left: 100px;
  .filing {
    position: fixed;
    left: 47%;
    bottom: 20px;
  }
}

.login-type{

  width: 100%;

  /deep/.el-radio-button{
    width: 50%;
  }

  /deep/.el-radio-button__inner{
    width: 100%;
  }

  /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #3e8ef7;
  }
}
</style>
